import { TextInput, Stack, Select, MultiSelect, Grid } from '@mantine/core';
import { TbUser } from 'react-icons/tb';

import { useSignUpFormContext } from '../../../../contexts/forms/SignUpFormContext';

import {
  COMPANY_SIZE_OPTIONS,
  COMPANY_LOCATION_OPTIONS,
  // COMPANY_INDUSTRIES,
} from '../../../../constants/signUpForm';

export default function CompanyDetails() {
  const { form } = useSignUpFormContext();

  return (
    <Stack>
      <Grid>
        <Grid.Col span={{ base: 12, sm: 8 }}>
          <TextInput
            withAsterisk
            label="Company Name"
            placeholder="Company Sdn Bhd"
            autoComplete="off"
            {...form.getInputProps('company_name')}
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 4 }}>
          <Select
            withAsterisk
            allowDeselect={false}
            label="Company Size"
            leftSection={<TbUser />}
            data={COMPANY_SIZE_OPTIONS}
            {...form.getInputProps('company_size')}
          />
        </Grid.Col>
      </Grid>
      {/* <Select
        withAsterisk
        placeholder="Select the closest matching industry"
        allowDeselect={false}
        label="Company Industry"
        data={COMPANY_INDUSTRIES}
        {...form.getInputProps('company_industry')}
      /> */}
      <MultiSelect
        withAsterisk
        searchable
        label="Company Locations"
        placeholder="Select locations"
        data={COMPANY_LOCATION_OPTIONS}
        {...form.getInputProps('locations')}
      />
      <TextInput
        label="How do you pay PCB today?"
        placeholder="Bank Transfer"
        autoComplete="off"
        {...form.getInputProps('pcb_question')}
      />
    </Stack>
  );
}
